import { masterClient } from '~/core/utils/clients/masterClient'

export type SiteSettings = {
  getContactsForFeedbackWeb: boolean
  phoneConfirmationViaVk: boolean
  hideEsiaConfirmationButton: boolean
  hideAchievements: boolean
}

export default {
  get() {
    return masterClient.get<SiteSettings>('/site_settings_flags/', { camelize: true })
  },
}
